import { useState } from 'react';

import VideoPlayerPop from '../about/components/VideoPlayerPop';

function _loadQQ() {
  const name = 'qqWindow';
  const iHeight = 600;
  const iWidth = 750;
  const iTop = (window.screen.height - 30 - iHeight) / 2; //获得窗口的垂直位置;
  const iLeft = (window.screen.width - 10 - iWidth) / 2; //获得窗口的水平位置;
  window.open(
    'https://wpa1.qq.com/zohvG78r?_type=wpa&qidian=true',
    name,
    'height=' +
      iHeight +
      ',innerHeight=' +
      iHeight +
      ',width=' +
      iWidth +
      ',innerWidth=' +
      iWidth +
      ',top=' +
      iTop +
      ',left=' +
      iLeft +
      ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no'
  );
}

const ContentComponent = ({ desc, color, name }) => {
  if (Array.isArray(desc)) {
    return desc.map((item, idx) => (
      <p key={idx} style={{ color, fontSize: color ? '20px' : '16px' }}>
        {item}
      </p>
    ));
  }

  return (
    <p style={{ color, fontSize: color ? '20px' : '16px' }}>
      <span>{desc}</span>
      {name === '企业QQ' && (
        <button className="flex" title="QQ联系我们" qq="4000800709" onClick={_loadQQ}>
          <span>4000800709</span>
          <img className="ml-[5px]" src="//static.szlcsc.com/ecp/assets/web/page/www/contact/images/qqqe.gif" />
        </button>
      )}
    </p>
  );
};

const contacts = [
  {
    jobWebsiteName: '客服热线',
    jobWebsiteImgUrl: '//static.szlcsc.com/ecp/assets/web/page/www/contact/images/gy_guanyuwm05.jpg',
    desc: '0755-83865666',
    color: '#0093e6',
  },
  {
    jobWebsiteName: '服务投诉',
    jobWebsiteImgUrl: '//static.szlcsc.com/ecp/assets/web/page/www/contact/images/gy_guanyuwm08.jpg',
    desc: '18165707450',
    color: '#0093e6',
  },
  {
    jobWebsiteName: '企业QQ',
    jobWebsiteImgUrl: '//static.szlcsc.com/ecp/assets/web/page/www/contact/images/gy_guanyuwm06.jpg',
    desc: '',
    color: '#0093e6',
  },
  {
    jobWebsiteName: '总部地址',
    jobWebsiteImgUrl: '//static.szlcsc.com/ecp/assets/web/page/www/contact/images/gy_guanyuwm09.jpg',
    desc: '深圳市福田区中康路136号新一代产业园1栋8楼',
  },
  {
    jobWebsiteName: '企业邮箱',
    jobWebsiteImgUrl: '//static.szlcsc.com/ecp/assets/web/page/www/contact/images/gy_guanyuwm07.jpg',
    desc: 'ic@szlcsc.com',
  },
  {
    jobWebsiteName: '仓库地址',
    jobWebsiteImgUrl: '//static.szlcsc.com/ecp/assets/web/page/www/contact/images/gy_guanyuwm10.jpg',
    desc: ['广东省珠海市斗门区乾务镇先进电子工业园1栋（广东仓）', '江苏省淮安市涟水县经济开发区兴隆路12号（江苏仓）'],
  },
];

const ContactContent = ({ mallData }) => {
  const [videoData, setVideoData] = useState(null);
  function handlePlayVideo({ way, url, poster }) {
    setVideoData({ way, url, poster });
  }

  return (
    <>
      {videoData && <VideoPlayerPop {...videoData} setVideoData={setVideoData} />}
      <section
        className="max-w-[3840px] h-[450px] flex justify-center items-center"
        style={{
          background: `url(${
            mallData.linkUsData.surfacePlotPictureUrl ||
            '//static.szlcsc.com/ecp/assets/web/static/images/about/companyprofile.png'
          }) center center no-repeat`,
          backgroundSize: 'auto 100%',
        }}
      >
        {mallData.linkUsData.uploadType === 'video' && (
          <img
            src="//static.szlcsc.com/ecp/assets/web/page/www/about/images/play-btn.svg"
            className="cursor-pointer"
            onClick={() =>
              handlePlayVideo({
                way: mallData.linkUsData.uploadWay,
                url: mallData.linkUsData.fileUrl,
                poster:
                  mallData.linkUsData.surfacePlotPictureUrl ||
                  '//static.szlcsc.com/ecp/assets/web/static/images/about/companyprofile.png',
              })
            }
          />
        )}
      </section>
      <section className="w-[1200px] text-[#666] text-[14px] mx-auto mt-[40px] pb-[10px]">
        <img
          className="w-[237px] h-[46px] mx-auto"
          src="//static.szlcsc.com/ecp/assets/web/page/www/contact/images/gy_gywm14_01.gif"
          alt="联系我们"
        />
        <ul className="mt-[30px] w-[970px] mx-auto  flex justify-center flex-wrap">
          {contacts.map((contact, idx) => (
            <li key={idx} className="h-full custom-group basis-1/2 flex mb-[30px]">
              <img className="size-[50px]" src={contact.jobWebsiteImgUrl} alt={contact.jobWebsiteName} />
              <section className="ml-[10px]">
                <p className="text-[16px]">{contact.jobWebsiteName}：</p>
                <ContentComponent
                  name={contact.jobWebsiteName}
                  desc={contact.desc}
                  color={contact.color}
                ></ContentComponent>
              </section>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
};

export default ContactContent;
